
import React, { useEffect, useState } from "react";
import { Box, Checkbox, Grid, Paper, Typography } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import styles from '.././../../styles.module.css';
import { Icon } from '@iconify/react';
import { StyledTableCell, StyledTableCellPrint, StyledTableRow, } from '../../reusableComponent/StyledTable'
import convertToIndianWords from "../../reusableComponent/convertToIndianWords";


const PaymentRegisterPrint = ({ reportPrint, acStatement }) => {

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };


    return (
        <>
            <style type="text/css" media="print">
                {`
                @page {
                    size: Landscape;
                }

                @media print {
                    .page-break {
                        page-break-after: always;
                    }

                    .page-break:empty {
                        display: none;
                    }
                }
            `}
            </style>
            <Box style={{ margin: '30px' }} className="print-source">
                <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', border: '1px solid #000000', height: '90vh' }}   >
                    <Grid container sx={{}}>
                        <Grid item xs={12} sx={{ backgroundColor: '#c0c0c0' }}>
                            <Typography sx={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', padding: '1px' }}>
                                PAYMENT REGISTER
                            </Typography>
                        </Grid>
                    </Grid>
                    <TableContainer component={Paper} style={{ overflowY: 'auto', }}>
                        <Table sx={{ minWidth: 650 }} size="small" stickyHeader >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Date</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Ref. No </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >{acStatement === 'Customer' ? 'Customer Name' : 'Supplier Name'} </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} >Payment</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Mode</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Payment Through</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} > Instrument/UTR No</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {reportPrint && reportPrint.map((row, index) => (
                                    <>
                                        <StyledTableRow
                                            key={row.pi_id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`} > {dateConversion(row.payment_date)} </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{(row.paymentReferenceNo)}</StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.CNS_id !== null ? row.CNS_Name : '-'}</StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.totalPaidAmt !== null ? row.totalPaidAmt.toFixed(2) : 'N/A'}</StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.payment_mode}</StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.bank_id == null ? '-' : row.bankName}</StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.instrumentNo !== null ? row.instrumentNo : '-'}</StyledTableCell>
                                        </StyledTableRow>
                                    </>
                                ))
                                }
                                {reportPrint && reportPrint.length != 0 &&
                                    <StyledTableRow >
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}></StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}></StyledTableCell>
                                        <StyledTableCell align="right" style={{fontSize:'16px', fontWeight:'bold',borderTop:'2px solid #c0c0c0'}}>Total:</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}>
                                            {(reportPrint.reduce((a, v) => a = a + parseFloat(v.totalPaidAmt), 0)).toFixed(2)}
                                        </StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}></StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}></StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}></StyledTableCell>
                                    </StyledTableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
        </>
    )
}
export default PaymentRegisterPrint;

